<template>
  <card body-classes="p-0">
    <!-- Card header -->
    <div class="row" slot="header">
      <div class="col">
        <h5 class="h3 mb-0">Aniversariantes do Mês</h5>
      </div>
    </div>
    <!-- Card body -->
    <ul class="list-group list-group-flush" data-toggle="checklist">
      <li
        class="checklist-entry list-group-item flex-column align-items-start py-4 px-4"
        v-for="user in users"
        :key="user.name"
      >
        <div class="row align-items-center">
          <div class="col ml--2">
            <h5 class="checklist-title mb-0">{{user.name}}</h5>
            <small>{{user.birthday}}</small>
          </div>
        </div>
      </li>
    </ul>
    <div slot="footer" class="py-4 d-flex justify-content-end">
      <base-pagination
        v-on:input="changePage"
        v-model="paginated_data['current']"
        :total="paginated_data['count']"
        :perPage="paginated_data['per_page']"
      ></base-pagination>
    </div>
  </card>
</template>
<script>

import moment from "moment";
export default {
  name: "general-task-list",
  data() {
    return {
      active: true,
      today: "",
      currentMonth: "",
      paginated_data: "",
      users: ""
    };
  },
  mounted(){
    this.getUsers('');
  },
  methods: {
    getUsers(page = null) {
      const q =  {
        page: page,
        q: { birthday: true },
        per_page: 5
      }
      this.$http.secured
        .get(`/api/v1/users/`, { params: q })
        .then((response) => {
          console.log(response)
          this.paginated_data = response.data
          this.users = this.paginated_data["users"];
          this.users.map(user => user.birthday = moment(user.birthday).format('L'))
        })
        .catch((error) => console.log(error, "Something went wrong"));
    },
    changePage(page) {
      this.getUsers(page);
    },
  },
};
</script>
<style></style>
